import * as React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

import './styles/ModalConfirmation.scss';

export class ModalConfirmationClass extends React.Component {
	render() {
		const { i18n, show, handleConfirmation, handleClose, title, body, closeButton,
			confirmButton, closeButtonStyle, confirmButtonStyle,
			closeButtonClass, confirmButtonClass } = this.props;

		return (
			// cacc-theme.css requires class of 'show' on dialog and backdrop
			<Modal show={show} className={show ? 'show' : ''} backdropClassName={show ? 'show' : ''} onHide={handleClose}>
				<Modal.Header>
					<Modal.Title>{title}</Modal.Title>
				</Modal.Header>

				<Modal.Body>{body}</Modal.Body>

				<Modal.Footer>
					<Button
						onClick={handleConfirmation}
						bsStyle={confirmButtonStyle ? confirmButtonStyle : 'primary'}
						className={confirmButtonClass ? confirmButtonClass : ''}
					>
						{confirmButton ? confirmButton : i18n.t('OK')}
					</Button>
					<Button
						onClick={handleClose}
						bsStyle={closeButtonStyle ? closeButtonStyle : 'default'}
						className={closeButtonClass ? closeButtonClass : ''}
					>
						{closeButton ? closeButton : i18n.t('CANCEL')}
					</Button>
				</Modal.Footer>
			</Modal>
		);
	}
}

ModalConfirmationClass.propTypes = {
	show: PropTypes.bool.isRequired,
	handleConfirmation: PropTypes.func.isRequired,
	handleClose: PropTypes.func.isRequired,
	title: PropTypes.string.isRequired,
	body: PropTypes.string.isRequired,
	closeButton: PropTypes.string.isRequired,
	confirmButton: PropTypes.string.isRequired,
	closeButtonStyle: PropTypes.string.isRequired,
	confirmButtonStyle: PropTypes.string.isRequired,
	closeButtonClass: PropTypes.string,
	confirmButtonClass: PropTypes.string.isRequired,
	i18n: PropTypes.shape({}).isRequired,
};

ModalConfirmationClass.defaultPropTypes = {
	closeButtonClass: '',
}

export default withTranslation()(ModalConfirmationClass);